import { useQuery } from '@hooks/reactQuery';

import { getOrganisationSettingsVendors } from '@api/organisationSettings';

import { IOrganisationSettingsVendors } from '@interfaces/organisation/organisations';

import { ORGANISATION_SETTINGS_VENDORS } from '@constants/queryKeys';

interface IUseQueryOrganisationSettingsVendorsReturn {
	organizationSettingsVendors?: IOrganisationSettingsVendors[];
	isLoadingOrganisationSettingsVendors: boolean;
}

export const useQueryOrganisationSettingsVendors = (): IUseQueryOrganisationSettingsVendorsReturn => {
	const {
		data: organizationSettingsVendors,
		isLoading: isLoadingOrganisationSettingsVendors,
		isFetching: isFetchingOrganisationSettingsVendors,
	} = useQuery<Array<IOrganisationSettingsVendors>>({
		queryKey: [ORGANISATION_SETTINGS_VENDORS],
		queryFn: getOrganisationSettingsVendors,
		refetchOnWindowFocus: false,
	});

	return {
		organizationSettingsVendors,
		isLoadingOrganisationSettingsVendors: isLoadingOrganisationSettingsVendors
			|| isFetchingOrganisationSettingsVendors,
	};
};
